import { PRICE_QUALIFIER_MAP } from '../constants/priceQualifiers.js'

const currencyFormatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  maximumFractionDigits: 0,
})

export const formatCurrency = (value = 0) => {
  if (!Number.isFinite(value)) return '£0'
  return currencyFormatter.format(value)
}

export const formatArea = (value = 0) => {
  if (!value) return '—'
  return `${Number(value).toLocaleString('en-GB')} sq ft`
}

export const formatPriceWithQualifier = (price = 0, qualifier = '') => {
  const option = PRICE_QUALIFIER_MAP[qualifier] || PRICE_QUALIFIER_MAP.guide_price
  const amountText = Number.isFinite(price) ? formatCurrency(price) : ''
  if (option?.hideAmount || !amountText) {
    return option?.prefix || amountText || ''
  }
  if (!option?.prefix) {
    return amountText
  }
  return `${option.prefix} ${amountText}`
}
